import { Input } from '@nextui-org/react'
import React from 'react'

export default function InputDefault(props) {
  const {
    name, type, label, placeholder, 
    isRequired=false, formData, errors={}, 
    onChange, 
    className="mb-4", 
    size="md", 
    disabled=false,
    startContent=null, endContent=null
  } = props
  return (
    <Input
      name={name} type={type} label={label}
      isRequired={isRequired}
      placeholder={placeholder}
      value={formData[name] || ''}
      color={errors[name] ? 'danger' : 'default'}
      errorMessage={errors[name]}
      onChange={onChange}
      className={`${className}`}
      size={size}
      startContent={startContent}
      endContent={endContent}
      disabled={disabled}
    />
  )
}
